import { createProvideInject } from '@collector/shared-ui'

export const [provideDefaultSkinPatternId, injectDefaultSkinPatternId] =
  createProvideInject<number>('defaultSkinPatternId')
